import React from "react"
import ReactDOM from "react-dom"
import PracticalCardContainer from "./practical-card-container"

export default class PracticalCardContainerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<PracticalCardContainer {...self.modelJson} />, self.elem)
  }
}
